import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import AllBlogs from '../../../components/AllBlogs';
import NewColumnWithForm from '../../../components/NewColumnWithForm';
import NewFeaturedBlogs from '../../../components/NewFeaturedBlogs';

export default function InsightsPage({
    global,
    all_news,
    all_featured_news
}) {
    return (
        <>
            <SeoHead
                page_name={`Insights | The global house of tech and transformation recruitment | Lorien | United States`}
                canonical_link={`insights`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`us.insights_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Insights</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-insights.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                breadcrumb_title="Insights"
            />
            <NewFeaturedBlogs
                global={global}
                pathPrefix={`us.insights_page.new_featured_blogs`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Featured Blogs</h2>
                    </>
                }
                post={all_featured_news}
                locale={`us`}

                socialPagePrefix={`us/insights`}
            />
            <AllBlogs
                global={global}
                pathPrefix={`us.news_page.all_blogs`}
                customClass={`py-5 lightGreybg`}
                post={all_news}
                ParentNews={true}
                locale={`us/`}

                heading={`All Blogs`}
            />
            <NewColumnWithForm
                global={global}
                pathPrefix={`us.insights_page.new_column_with_form`}
                customClass={`pb-5`}
                heading={`How can we help you?`}
                formId={`c5e3d9d7-fe11-4ba2-a819-f35994bb78e9`}
                locale={`us`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const featured_news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.country?.en == "United States" || post.country?.en == "All"
            );
        })
        .filter(function (post) {
            return (
                post.featured?.en == true
            );
        });

    const news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.country?.en == "United States" || post.country?.en == "All"
            );
        })

    const all_news = news.orderBy('date').getItems();
    const all_featured_news = featured_news.orderBy('date').getItems();
    return {
        props: {
            global,
            all_news,
            all_featured_news
        }
    };
}
